import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveApprovalMatrixType } from './index';

// Api's
import { approvalMatrixTypeApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getApprovalMatrixTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      approvalMatrixTypeApi.getDomain
    );

    if (response.data.result) {
      yield put(saveApprovalMatrixType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveApprovalMatrixType(
          null,
          true,
          resultError.messagesDataError
        )
      );
    }
  }
}